import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "adjustDiscountModal",
    "adjustMaximumModal",
    "editQuoteLineModal",
  ]

  showAdjustDiscountModal() {
    $(this.adjustDiscountModalTarget).modal("show")
  }

  showAdjustMaximumModal() {
    $(this.adjustMaximumModalTarget).modal("show")
  }

  showEditQuoteLineModal() {
    $(this.editQuoteLineModalTarget).modal("show")
  }
}
